import { message } from 'antd';
import axios from 'axios'
import { API_URL } from '../const';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
        window.location.href = '/login'
    } else {
        const msg = error?.response?.data;
        const errorMsg = Object.values(msg).join(", ");
        message.error(errorMsg)
    }
    return Promise.reject(error);
  }
);

export default api;